import React, { useState } from "react";
import {
  Drawer,
  Box,
  Typography,
  List,
  ListItem,
  Divider,
  IconButton,
  Button,
} from "@mui/material";

import { Add, Remove, Delete, CancelRounded } from "@mui/icons-material";
import colors from "../../config/colors";
import LoginDialog from "../login";
import RegisterDialog from "../register";
import CheckoutDialog from "../checkout";

const ShoppingCart = ({ open, onClose, cart, setCart }) => {
  const [checkoutOpen, setCheckoutOpen] = useState(false);
  const [loginOpen, setLoginOpen] = useState(false);
  const [registerOpen, setRegisterOpen] = useState(false);

  const increase = (index) => {
    const items = [...cart];

    if (items[index].quantity < Number(items[index].stock)) {
      items[index].quantity++;
      setCart(items);
    }
  };

  const decrease = (index) => {
    const items = [...cart];

    if (items[index].quantity > 1) {
      items[index].quantity--;
      setCart(items);
    }
  };

  const removeItem = (index) => {
    const items = cart.filter((_, i) => i !== index);
    setCart(items);
  };

  const total = cart.reduce((sum, item) => sum + item.price * item.quantity, 0);

  return (
    <Box>
      <Drawer anchor="right" open={open} onClose={onClose}>
        <Box
          sx={{
            width: 380,
            p: 2,
            mt: 10,
            display: "flex",
            flexDirection: "column",
            height: "100%",
          }}
        >
          <Box
            sx={{
              display: "flex",
              alignItems: "center",
              justifyContent: "space-between",
              width: "100%",
            }}
          >
            <Typography
              variant="h5"
              sx={{
                fontSize: {
                  xs: "1.2rem",
                  sm: "1.5rem",
                },
                fontWeight: "bold",
                whiteSpace: "nowrap",
                overflow: "hidden",
                textOverflow: "ellipsis",
              }}
            >
              Carrinho de Compras
            </Typography>

            <IconButton onClick={onClose} sx={{ ml: 1, flexShrink: 0 }}>
              <CancelRounded fontSize="large" sx={{ color: colors.primary }} />
            </IconButton>
          </Box>

          <Divider sx={{ my: 2 }} />

          {cart.length === 0 && <Typography>O carrinho está vazio.</Typography>}

          <List>
            {cart.map((item, index) => (
              <ListItem
                key={index}
                sx={{
                  display: "block",
                  mb: 2,
                  px: 0,
                }}
              >
                {/* Top Row */}
                <Box
                  sx={{
                    display: "flex",
                    alignItems: "center",
                    gap: 2,
                  }}
                >
                  <Box
                    component="img"
                    src={item.image}
                    alt={item.title}
                    sx={{
                      width: 70,
                      height: 70,
                      objectFit: "cover",
                      borderRadius: 2,
                      flexShrink: 0,
                    }}
                  />

                  <Box sx={{ flex: 1, minWidth: 0 }}>
                    <Typography fontWeight="bold" noWrap>
                      {item.title}
                    </Typography>

                    <Typography variant="body2" color="text.secondary" noWrap>
                      {item.product_code}
                    </Typography>

                    <Typography fontWeight="bold" color="primary">
                      {Number(item.price).toLocaleString()}{" "}
                      {item.location?.toLowerCase().includes("lisboa")
                        ? "€"
                        : "Kz"}
                    </Typography>
                  </Box>
                </Box>

                {/* Bottom Row */}
                <Box
                  sx={{
                    mt: 2,
                    display: "flex",
                    justifyContent: "space-between",
                    alignItems: "center",
                  }}
                >
                  <Box
                    sx={{
                      display: "flex",
                      alignItems: "center",
                      border: "1px solid #ddd",
                      borderRadius: 2,
                    }}
                  >
                    <IconButton size="small" onClick={() => decrease(index)}>
                      <Remove fontSize="small" />
                    </IconButton>

                    <Typography
                      sx={{
                        minWidth: 30,
                        textAlign: "center",
                        fontWeight: "bold",
                      }}
                    >
                      {item.quantity}
                    </Typography>

                    <IconButton size="small" onClick={() => increase(index)}>
                      <Add fontSize="small" />
                    </IconButton>
                  </Box>

                  <IconButton color="error" onClick={() => removeItem(index)}>
                    <Delete />
                  </IconButton>
                </Box>

                <Divider sx={{ mt: 2 }} />
              </ListItem>
            ))}
          </List>

          <Typography variant="h6" mt={2}>
            Total: {total.toLocaleString()}{" "}
            {cart.some((item) =>
              item.location?.toLowerCase().includes("lisboa"),
            )
              ? "€"
              : "Kz"}
          </Typography>
          <Box
            sx={{
              display: "flex",
              gap: 1,
              mt: 2,
            }}
          >
            <Button
              fullWidth
              variant="contained"
              disabled={cart.length === 0}
              onClick={() => {
                const user = JSON.parse(localStorage.getItem("customer"));
                if (!user) {
                  setLoginOpen(true);
                  return;
                }
                setCheckoutOpen(true);
              }}
            >
              Checkout
            </Button>
            <CheckoutDialog
              open={checkoutOpen}
              onClose={() => setCheckoutOpen(false)}
              cart={cart}
              setCart={setCart}
            />
          </Box>
        </Box>
      </Drawer>
      <LoginDialog
        open={loginOpen}
        onClose={() => setLoginOpen(false)}
        onRegister={() => {
          setLoginOpen(false);
          setRegisterOpen(true);
        }}
      />
      <RegisterDialog
        open={registerOpen}
        onClose={() => setRegisterOpen(false)}
        onLogin={() => setLoginOpen(true)}
      />
    </Box>
  );
};

export default ShoppingCart;
